export default [
    {
        key: "todo",
        name: "Todo",
        date: "July, 2020",
        description:
            "A simple todo app that allows you to create, update, and delete tasks. Auth0 integration is also included, as well as a working frontend.",
        frontendFolder: "todo-app-react",
        frontend: ["React"],
        backend: ["Slash GraphQL"],
        license: "Apache-2.0 License",
        frontendRepo:
            "https://github.com/dgraph-io/graphql-sample-apps/tree/master/todo-app-react",
        schemaUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/todo-app-react/one-click/schema.graphql",
        mutationsUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/todo-app-react/one-click/mutations.graphql",
        image:
            "https://user-images.githubusercontent.com/9936881/95045751-5442f200-0700-11eb-8e08-5a19ff516124.png",
        features: ["Add Todo", "Delete Todo", "Update Todo", "Edit Todo"],
        hostedUrl: "",
    },
    {
        key: "charting",
        name: "Charts",
        date: "July, 2020",
        description:
            "The chart app allows you to record metrics and plot them on a line chart. This app also has an easy way to generate data for you to have positive looking charts.",
        frontendFolder: "charting",
        frontend: ["React"],
        backend: ["Slash GraphQL"],
        license: "Apache-2.0 License",
        frontendRepo:
            "https://github.com/dgraph-io/graphql-sample-apps/tree/master/charting",
        schemaUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/charting/schema.graphql",
        image:
            "https://user-images.githubusercontent.com/9936881/95045756-560cb580-0700-11eb-9d34-c4512f956910.png",
        hostedUrl: "",
    },
    {
        key: "surveyo",
        name: "Surveyo",
        date: "September, 2020",
        featured: true,
        description:
            "Surveyo is the first GraphQL based Survey tool. Generate beautiful surveys, and visualize your data using the inbuilt reports. Advanced users can query data across polls using GraphQL.",
        frontendFolder: "surveyo",
        frontend: ["React", "Ant Design"],
        backend: ["Slash GraphQL", "Auth0"],
        license: "Apache-2.0 License",
        frontendRepo: "https://github.com/dgraph-io/surveyo",
        schemaUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/surveyo/schema.graphql",
        image:
            "https://github.com/dgraph-io/graphql-sample-apps/raw/master/surveyo/public/charts.png",
        features: [
            "Supports Short Answer, MCQs, Date Query and Rating type of questions",
            "Visualize responses collected as Pie Chart, Word Cloud and Bar chart",
            "Provides GraphiQL IDE to make GraphQL queries",
        ],
        hostedUrl: "https://surveyo.one-click.cloud.dgraph.io/",
    },
    {
        key: "dev-jokes",
        name: "DevJokes",
        date: "September, 2020",
        license: "Apache-2.0 License",
        description:
            "Devjokes is an app which provides you a medium to share and laugh on developer jokes.",
        frontendFolder: "dev-jokes",
        frontend: ["React", "Material UI"],
        backend: ["Slash GraphQL", "Auth0"],
        frontendRepo: "https://github.com/dgraph-io/dev-jokes",
        schemaUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/dev-jokes/one-click/schema.graphql",
        mutationsUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/dev-jokes/one-click/mutations.graphql",
        image:
            "https://user-images.githubusercontent.com/9936881/95045762-573de280-0700-11eb-8b64-cf84c23fc219.png",
        features: [
            "Support two kind of jokes: Text Joke and Meme",
            "Moderated content to feed you the best jokes and add enable better searching.",
            "Logged in users can like and share the jokes.",
            "Community moderation enabled through flagging.",
        ],
        hostedUrl: "https://devjokes.netlify.app/",
    },
    {
        key: "pokedex",
        date: "September, 2020",
        name: "Pokedex",
        license: "Apache-2.0 License",
        description:
            "Pokédex React app implemented with a Slash GraphQL backend. Can see all pokemon and sort through them by type.",
        frontendFolder: "pokedex",
        frontend: ["React"],
        backend: ["Slash GraphQL"],
        frontendRepo: "https://github.com/thawkin3/pokedex-slash-graphql",
        schemaUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/pokedex/snippets/schema.graphql",
        mutationsUrl:
            "https://raw.githubusercontent.com/dgraph-io/graphql-sample-apps/master/pokedex/snippets/add-all-pokemon.graphql",
        image:
            "https://user-images.githubusercontent.com/9936881/95045763-57d67900-0700-11eb-840a-a9a80cb6b1ed.png",
        features: ["Filter Pokemon by type", "Filter Pokemon by Captured"],
        hostedUrl: "",
    },
];
